import React, { ReactNode, ErrorInfo } from "react";

interface ErrorBoundryProps {
  children: ReactNode;
  errorComponent: ReactNode;
}

interface ErrorBoundryState {
  hasError: boolean;
}

class ErrorBoundryComponent extends React.Component<
  ErrorBoundryProps,
  ErrorBoundryState
> {
  constructor(props: ErrorBoundryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundryState {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <>{this.props.errorComponent}</>;
    }

    return this.props.children;
  }
}

export default ErrorBoundryComponent;
